import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import ProtectedRoute from './components/ProtectedRoute';
import RoleRoute from './components/RoleRoute';
import { ROLES } from './lib/roles';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import AdminPanel from './pages/AdminPanel';
import RouteNew from './pages/RouteNew';
import Reports from './pages/Reports';
import Vehicles from './pages/Vehicles';
import FleetOptimize from './pages/FleetOptimize';
import RoutesPage from './pages/Routes';
import RouteDetail from './pages/RouteDetail';
import Depots from './pages/Depots';
import BI from './pages/BI';
import WhatsAppTracking from './pages/WhatsAppTracking';
import Settings from './pages/Settings';
import PublicTracking from './pages/PublicTracking';
import DriverMode from './pages/DriverMode';
import Expenses from './pages/Expenses';
import ChangePassword from './pages/ChangePassword';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Public Standalone Customer Tracking */}
            <Route path="/track/:code" element={<PublicTracking />} />
            <Route path="/tracking/:id" element={<PublicTracking />} />

            {/* Driver Immersive Fullscreen Mode */}
            <Route path="/motorista/:id" element={<DriverMode />} />
            <Route path="/driver/:id" element={<DriverMode />} />

            {/* Protected Operations */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rotas"
              element={
                <ProtectedRoute>
                  <RoutesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rotas/nova"
              element={
                <ProtectedRoute>
                  <RouteNew />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rotas/:id/editar"
              element={
                <ProtectedRoute>
                  <RouteNew />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rotas/desenhar"
              element={
                <ProtectedRoute>
                  <Navigate to="/rotas/nova" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rota"
              element={
                <ProtectedRoute>
                  <Navigate to="/rotas/nova" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rotas/:id"
              element={
                <ProtectedRoute>
                  <RouteDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/frota/nova"
              element={
                <ProtectedRoute>
                  <FleetOptimize />
                </ProtectedRoute>
              }
            />
            <Route
              path="/frota"
              element={
                <ProtectedRoute>
                  <FleetOptimize />
                </ProtectedRoute>
              }
            />
            <Route
              path="/veiculos"
              element={
                <ProtectedRoute>
                  <Vehicles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/depositos"
              element={
                <ProtectedRoute>
                  <Depots />
                </ProtectedRoute>
              }
            />
            <Route
              path="/relatorios"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/custos"
              element={
                <ProtectedRoute>
                  <BI />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lancamentos"
              element={
                <ProtectedRoute>
                  <Expenses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bi"
              element={
                <ProtectedRoute>
                  <BI />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp"
              element={
                <ProtectedRoute>
                  <WhatsAppTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracoes"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trocar-senha"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/usuarios"
              element={
                <RoleRoute allow={[ROLES.ADMIN]}>
                  <Users />
                </RoleRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <RoleRoute allow={[ROLES.SUPER_ADMIN]}>
                  <AdminPanel />
                </RoleRoute>
              }
            />

            {/* Default fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
